import { render, staticRenderFns } from "./PermitToWork.vue?vue&type=template&id=9dc73ec8&scoped=true"
import script from "./PermitToWork.vue?vue&type=script&lang=js"
export * from "./PermitToWork.vue?vue&type=script&lang=js"
import style0 from "./PermitToWork.vue?vue&type=style&index=0&id=9dc73ec8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dc73ec8",
  null
  
)

export default component.exports